class ThankYouController {
  /* @ngInject */
  constructor($state, $stateParams) {
    this.$state = $state;
    this.$stateParams = $stateParams;
  }
  $onInit() {}
}

export default ThankYouController;



// WEBPACK FOOTER //
// ./client/app/thank-you/thank-you.controller.js